import React, {useEffect, useState} from "react";
import {Link, useNavigate} from 'react-router-dom';
import Preloader from "../Include/PreLoader";
import AIBackground from "../../functions/AIBackground";
import PandaPickLogo from "../../assets/icon.png";
import API_URL from "../../functions/config";

const MarkAttendance = () => {

		const [loading, setLoading] = useState(false);
		const [emailid, setEmail]= React.useState('');
		const [OTP, setOTP]= React.useState('');
		const navigate=useNavigate();
	
		 useEffect(()=>{
					const auth=localStorage.getItem('empuser');
					if(auth){
						navigate('/time-tracker');
					}
				})
	
const markatt = async () => {

    setLoading(true);

    try {

        // ==========================================
        // 1. GET EMPLOYEE CURRENT LOCATION
        // ==========================================

        const position = await new Promise((resolve, reject) => {

            if (!navigator.geolocation) {
                reject({
                    code: 0,
                    message: "Geolocation is not supported by this browser."
                });
                return;
            }

            navigator.geolocation.getCurrentPosition(
                resolve,
                reject,
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
            );

        });


        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;


        console.log("=================================");
        console.log("EMPLOYEE LOCATION");
        console.log("Latitude:", latitude);
        console.log("Longitude:", longitude);
        console.log("=================================");


        // ==========================================
        // 2. CALL EMPLOYEE LOGIN API
        // ==========================================

        const response = await fetch(
            `${API_URL}/employee-login`,
            {
                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    emailid: emailid,
                    OTP: OTP,
                    latitude: latitude,
                    longitude: longitude
                })
            }
        );


        // ==========================================
        // 3. DEBUG HTTP RESPONSE
        // ==========================================

        console.log("=================================");
        console.log("LOGIN API RESPONSE");
        console.log("HTTP Status:", response.status);
        console.log("HTTP OK:", response.ok);
        console.log("Content-Type:", response.headers.get("content-type"));
        console.log("=================================");


        // ==========================================
        // 4. GET RAW RESPONSE
        // ==========================================

        const responseText = await response.text();

        console.log("RAW API RESPONSE:");
        console.log(responseText);


        // ==========================================
        // 5. CONVERT RESPONSE TO JSON
        // ==========================================

        let result;

        try {

            result = JSON.parse(responseText);

        } catch (jsonError) {

            console.error(
                "JSON PARSE ERROR:",
                jsonError
            );

            console.error(
                "SERVER RESPONSE:",
                responseText
            );

            alert(
                "Server returned an invalid response. Please check the console."
            );

            return;
        }


        // ==========================================
        // 6. SHOW COMPLETE LOGIN RESPONSE
        // ==========================================

        console.log("=================================");
        console.log("LOGIN RESPONSE OBJECT:");
        console.log(result);
        console.log("=================================");


        // ==========================================
        // 7. LOGIN SUCCESS
        // ==========================================

        if (response.ok && result.token) {

            console.log("LOGIN SUCCESSFUL");


            // Save employee information
            localStorage.setItem(
                "empuser",
                JSON.stringify(result.employee)
            );


            // Save JWT token
            localStorage.setItem(
                "emptoken",
                result.token
            );


            // Go to time tracker
            navigate("/time-tracker");


            return;
        }


        // ==========================================
        // 8. TIME RESTRICTION ERROR
        // ==========================================

        if (result.restriction === "time") {

            alert(
                result.message ||
                "You are not allowed to login at this time."
            );

            return;
        }


        // ==========================================
        // 9. LOCATION RESTRICTION ERROR
        // ==========================================

        if (result.restriction === "location") {

            if (result.distance !== undefined) {

                alert(
                    `${result.message}\n\nDistance from office: ${result.distance} meters`
                );

            } else {

                alert(
                    result.message ||
                    "You are out of the Office. Login is not allowed."
                );
            }

            return;
        }


        // ==========================================
        // 10. OTHER API ERROR
        // ==========================================

        alert(
            result.message ||
            "Incorrect Details"
        );


    } catch (error) {

        // ==========================================
        // 11. ERROR HANDLING
        // ==========================================

        console.error(
            "================================="
        );

        console.error(
            "EMPLOYEE LOGIN ERROR:"
        );

        console.error(error);

        console.error(
            "================================="
        );


        // Location permission denied
        if (error.code === 1) {

            alert(
                "Location permission is required to login."
            );

        }

        // Location unavailable
        else if (error.code === 2) {

            alert(
                "Unable to get your current location."
            );

        }

        // Location timeout
        else if (error.code === 3) {

            alert(
                "Location request timed out. Please try again."
            );

        }

        // Other error
        else {

            alert(
                error.message ||
                "Something went wrong. Please try again."
            );
        }

    } finally {

        // ==========================================
        // 12. STOP LOADING
        // ==========================================

        setLoading(false);

    }
};

    return(
        <>
		  <div className='hero-section'>
            <AIBackground />

        <div className="container h-100">
		<div className="d-flex justify-content-center h-100">
			<div className="user_card">
				<div className="d-flex justify-content-center">
					<div className="brand_logo_container">
						<img src={PandaPickLogo} className="img-fluid" alt="Logo"/>
					</div>

					<h3 className="text-center text-white fw-light"> Mark <b className="fw-bold">Attendance</b></h3>


				</div>
				<div className="d-flex justify-content-center form_container">
					   {loading ? (
                <Preloader show={loading} />
            ) : (
                <>
					<form>
						<div className="input-group mb-3">
							<div className="input-group-append">
								<span className="input-group-text"><i className="fas fa-user"></i></span>
							</div>
							<input type="text"  className="form-control input_user" onChange={(e)=>setEmail(e.target.value)} value={emailid}  placeholder="Your Email ID"/>
						</div>
						<div className="input-group mb-2">
							<div className="input-group-append">
								<span className="input-group-text"><i className="fas fa-key"></i></span>
							</div>
							<input type="password" className="form-control input_pass" autoComplete="on" onChange={(e)=>setOTP(e.target.value)} value={OTP} placeholder="OTP"/>
						</div>
						
							<div className="d-flex justify-content-center mt-3 login_container">
				 	<button type="button" name="button" onClick={markatt} className="btn-start-free">Mark Attendance</button>
				   </div>
					</form>
					   </>
            )}
				</div>
		
				<div className="mt-4">
					
					<div className="d-flex justify-content-center links">
						<Link to="">Resend OTP?</Link>
					</div>
				</div>
			</div>
		</div>
	</div>

	</div>
        </>
    )

}

export default MarkAttendance;